import "../cs.scss";
import "./csprefactor.scss";
import { useTranslation } from "react-i18next";
import { Breadcrumb, Button, Col, Image, Row, Steps, message } from "antd";
import { _adr } from "../../../../address";
import { HomeOutlined } from "@ant-design/icons";
import { Content } from "antd/es/layout/layout";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { complexDigitToman, fileToBase64, isEmpty } from "../../../../tools/tools";
import Loading from "../../../auxiliary/loader/loading";
import { useAPIPublic, useDealer } from "../../../../tools/api";
import IncressCharge from "../../../auxiliary/incressCharge/charge";
import { globalValue } from "../../../../reducer/serviceReducerGlobala";

const CSPrefactor = () => {
  const [t] = useTranslation("global");
  const formData = useSelector((state) => state);
  const dispatch = useDispatch();
  const [searchParam] = useSearchParams();
  const nav = useNavigate();
  const [previewData, setPreviewData] = useState();
  const [openIncress, setOpenIncress] = useState(false);
  const [localInvoiceId, setLocalInvoiceId] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const bankRef = useRef("");
  const [priceSw, setPriceSw] = useState(0);
  const [purchaseID, setPurchaseID] = useState(0);
  const [tax, setTax] = useState(0);
  const [taxPrice, setTaxPrice] = useState(0);
  const { sWPreFactor, calculateSWCommissionPrice } = useDealer();
  const { queryTaxPercent } = useAPIPublic();
  const [wallet, setWallet] = useState(0);
  const [changeWallet, setChangeWallet] = useState();
  const [commission, setCommission] = useState(0);
  const [messageApi, contextHolder] = message.useMessage();

  const [changeSimCardDocument, setChangeSimCardDocument] = useState();
  useEffect(() => {
    const initialCheckState = async () => {
      try {
        if (!isEmpty(searchParam.get("localInvoiceId"))) {
          setPreviewData(formData?.another.swchange);
          const getLocalInvoiceID = searchParam.get("localInvoiceId");
          setLocalInvoiceId(getLocalInvoiceID);
          setOpenIncress(true);
          setPurchaseID(formData?.another.swchange.purchaseid);
          const simcardDoc = await fileToBase64(formData?.another.swchange?.photo);
          setChangeSimCardDocument(simcardDoc);
          formData.from = formData?.another.swchange;
        } else {
          setPreviewData(formData?.from || {});
          const simcardDoc = await fileToBase64(formData?.from?.swchange?.photo || formData?.another?.swchange?.photo);
          setChangeSimCardDocument(simcardDoc);
        }
      } catch (error) {
        console.error(error);
      }
    };
    initialCheckState();
  }, []);
  useEffect(() => {
    const CallInitial = async () => {
      try {
        let resTax = await queryTaxPercent();
        if (resTax) setTax(parseInt(resTax));
        //call CalC Price SW
        let payload = {
          msisdn: previewData?.swchange?.msisdn,
          certno: previewData?.swchange?.certno,
        };
        let response = await sWPreFactor(payload);
        if (response) {
          setPriceSw(response.productPrice);
          setPurchaseID(response.spPurchaseId);
          let payCommission = {
            msisdn: previewData?.swchange?.msisdn,
            productid: response?.productid,
            iccid: previewData?.swchange?.kitno,
          };
          let resCommission = await calculateSWCommissionPrice(payCommission);
          if (resCommission) {
            setCommission(resCommission?.commission);
          }
        }
      } catch (error) {
        console.error(error);
      }
    };
    if (previewData) {
      CallInitial();
    }
  }, [previewData]);
  useEffect(() => {
    try {
      if (tax > 0 && priceSw > 0) {
        let total = (priceSw * tax) / 100;
        setTaxPrice(total);
      }
    } catch (error) {
      console.error(error);
    }
  }, [tax, priceSw]);
  useEffect(() => {
    setWallet(formData?.another?._currentUser?.walletAmount);
  }, [formData?.another?._currentUser?.walletAmount, changeWallet]);
  const handleCallBackCharge = (value) => {
    try {
      if (value?.length > 0) {
        // dispatch(clearFormData());
        dispatch(globalValue({ swchange: { ...formData.from, purchaseid: purchaseID } }));
        bankRef.current.innerHTML = value;
        document.querySelector('form[action="https://asan.shaparak.ir"]').submit();
      } else {
        setLocalInvoiceId("");
        setOpenIncress(false);
        setChangeWallet(Date.now());
      }
    } catch (error) {
      console.error(error);
    }
  };
  const handleSubmit = async () => {
    if (purchaseID) {
      nav(_adr.Root + _adr.SimCardReplacement.Index + _adr.SimCardReplacement.Replacement + _adr.SimCardReplacement.Document, {
        state: {
          spPurchaseId: purchaseID,
        },
      });
    } else {
      messageApi.open({
        type: "error",
        content: "سریال خرید سیم کارت وجود ندارد",
      });
    }

    // if (wallet - (taxPrice + priceSw) >= 0) {

    // } else {
    //   messageApi.open({
    //     type: "error",
    //     content: "موجودی کیف پول کافی نمی باشد.",
    //   });
    // }
  };

  return (
    <>
      <div className="container-main container-cs">
        {contextHolder}
        <div className="g-hold-title-of-page">
          <Breadcrumb
            className="breadcrumbs"
            items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("simcardreplacement.validPage.title") }]}
          />
          <div className="title-page">
            <h3>{t("simcardreplacement.validPage.title")}</h3>
            <p></p>
          </div>
        </div>
        <div className="g-layout-content">
          <Content className="g-layout-main cs-container">
            <div className="g-format-page">
              <div className="g-body-format-page">
                <div className="g-format-steps">
                  <div className="holder-step">
                    <Steps
                      size="small"
                      className="step-wizard"
                      current={2}
                      items={[
                        {
                          title: "احراز هویت",
                        },
                        {
                          title: "مشخصات سیم‌کارت",
                        },
                        {
                          title: "پیش فاکتور",
                        },
                        {
                          title: "فرم تعویض سیم‌کارت",
                        },
                      ]}
                    />
                  </div>
                </div>
                <div className="cs-prefactor-container">
                  <div className="g-prefactor">
                    <div className="holder-row-prefactor">
                      <Row gutter={16}>
                        <Col span={14} xl={14} lg={14} md={24} sm={24} xs={24}>
                          <div className="for-pay-client">
                            <h3>صورت حساب مشتری</h3>
                            <div className="holder-box">
                              <div className="holder-profile">
                                <h4>
                                  مشخصات سیم کارت{" "}
                                  <Link
                                    to={
                                      _adr.Root +
                                      _adr.SimCardReplacement.Index +
                                      _adr.SimCardReplacement.Replacement +
                                      _adr.SimCardReplacement.ValidKit
                                    }
                                    state={{
                                      msisdn: previewData?.swchange?.msisdn,
                                      certno: previewData?.swchange?.certno,
                                    }}
                                  >
                                    <i className="icon-edit"></i>
                                  </Link>
                                </h4>
                                <div className="list-item">
                                  <div className="item">
                                    <div className="label">شماره موبایل:</div>
                                    <div className="value">
                                      <span dir="ltr">{previewData?.swchange?.msisdn}</span>
                                    </div>
                                  </div>
                                  <div className="item">
                                    <div className="label">کد ملی:</div>
                                    <div className="value">
                                      <span dir="ltr">{previewData?.swchange?.certno}</span>
                                    </div>
                                  </div>
                                  <div className="item">
                                    <div className="label">علت تعویض سیم کارت:</div>
                                    <div className="value">{previewData?.swchange?.reasontext}</div>
                                  </div>
                                </div>
                              </div>
                              <div className="divider"></div>
                              <div className="holder-profile">
                                <div className="list-item">
                                  <div className="item">
                                    <div className="label">شماره کیت جدید:</div>
                                    <div className="value">
                                      <span dir="ltr">{previewData?.swchange?.kitno}</span>
                                    </div>
                                  </div>
                                  <div className="item">
                                    <div className="label">تصویر کارت ملی:</div>
                                    <div className="value">
                                      <div className="show-document">
                                        <Button onClick={() => setIsVisible(true)} type="link">
                                          بارگذاری شده
                                        </Button>
                                        <Image
                                          preview={{
                                            visible: isVisible,
                                            onVisibleChange: (value) => setIsVisible(value),
                                          }}
                                          src={changeSimCardDocument}
                                          style={{ display: "none" }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col span={10} xl={10} lg={10} md={24} sm={24} xs={24}>
                          <div className="for-pay-agent">
                            <h3>صورت حساب فروشنده</h3>
                            <div className="holder-box">
                              <div className="holder-list-pay">
                                <ul>
                                  <li>
                                    <div className="label">هزینه تعویض سیم‌کارت</div>
                                    <div className="value">
                                      <span dir="ltr">{complexDigitToman(priceSw)}</span> تومان
                                    </div>
                                  </li>
                                  <li>
                                    <div className="label">مالیات ({tax}درصد)</div>
                                    <div className="value">
                                      <span dir="ltr">{complexDigitToman(taxPrice)}</span> تومان
                                    </div>
                                  </li>
                                  <li>
                                    <div className="label">مبلغ قابل دریافت از مشتری</div>
                                    <div className="value">
                                      <span dir="ltr">{complexDigitToman(taxPrice + priceSw)}</span> تومان
                                    </div>
                                  </li>
                                </ul>
                                <div className="hold-message success">
                                  <p>این مبلغ از کیف پول شما برداشت می‌شود</p>
                                  <h3>
                                    <span dir="ltr">{complexDigitToman(Math.abs(commission))}</span> تومان
                                  </h3>
                                </div>
                                {/* {wallet - (taxPrice + priceSw) >= 0 ? (
                                  ""
                                ) : (
                                  <>
                                    <div className="hold-message success">
                                      <p>این مبلغ از کیف پول شما برداشت می‌شود</p>
                                      <h3>
                                        <span dir="ltr">{complexDigitToman(taxPrice + priceSw)}</span>
                                        تومان
                                      </h3>
                                    </div>
                                    <div className="hold-message error">
                                      <div className="row-message">
                                        <div className="holder-text">
                                          <h3>اعتبار شما کافی نمی‌باشد</h3>
                                          <ul>
                                            <li>
                                              <div className="label">کسری اعتبار: </div>
                                              <div className="value">
                                                <span dir="ltr">{complexDigitToman(taxPrice + priceSw - wallet)} </span> تومان
                                              </div>
                                            </li>
                                          </ul>
                                        </div>
                                        <div className="holder-acction">
                                          <div className="holder-button">
                                            <Button className="btn-normal" htmlType="button" onClick={() => setOpenIncress(true)}>
                                              افزایش اعتبار
                                            </Button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                )} */}
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
              <div className="g-footer-format-page">
                <div className="holder-button">
                  <Button className="btn-normal btn-aptel" type="primary" danger onClick={handleSubmit}>
                    مرحله بعد
                  </Button>
                  <Button
                    className="btn-normal"
                    onClick={() => {
                      nav(_adr.Root + _adr.SimCardReplacement.Index + _adr.SimCardReplacement.Replacement + _adr.SimCardReplacement.ValidKit);
                    }}
                    type="default"
                  >
                    بازگشت
                  </Button>
                </div>
              </div>
            </div>
          </Content>
        </div>
      </div>

      <Loading isOpen={isLoading} />
      <IncressCharge
        open={openIncress}
        planid={process.env.REACT_APP_PLANID_CHARGE_WALLET_CS}
        msisdn={formData?.another?._currentUser?.telnoone}
        price={taxPrice + priceSw - wallet}
        callback={handleCallBackCharge}
        localInvoiceId={localInvoiceId}
      />
      <div ref={bankRef}></div>
    </>
  );
};

export default CSPrefactor;
